import { getFeedbackAreasForSelection } from './getFeedbackAreasForSelection';
import { getClassification } from '../selectors/getClassification';
import { FeedbackClassification } from '../store/schema/FeedbackClassification';

export function hasDebugInfo(): boolean {
    return (
        getFeedbackAreasForSelection().some(area => !!area.getDebugLogAttachmentDetails) &&
        getClassification() === FeedbackClassification.Bug
    );
}
